import { SxProps, Theme } from '@mui/material';

import { smallScreenSX as baseSmallScreenSX } from '../dialogStyles';

export { DialogActionStyles, DialogButton } from '../dialogStyles';

/** Bottom-sheet presentation, plus this dialog's own typography colour. */
export const smallScreenSX: SxProps<Theme> = (theme) => ({
    ...(baseSmallScreenSX as object),
    typography: {
        color: theme.palette.grey[900],
    },
});

export const DialogContentStyles: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
};
